import React from "react";

export default () => {
  return <div className="shadow-box videos w-inline-block invi" />;
};
